export const specialRequestType = {
  bed_prefs: 'bed_prefs',
  smoking_prefs: 'smoking_prefs',
  extra_prefs: 'extra_prefs',
};
